export const COUNTRY_CODE_NAME =  {
    "AF": "Afghanistan",
    "AL": "Albanie",
    "DZ": "Algérie",
    "AD": "Andorre",
    "AO": "Angola",
    "AG": "Antigua-et-Barbuda",
    "AR": "Argentine",
    "AM": "Arménie",
    "AU": "Australie",
    "AT": "Autriche",
    "AZ": "Azerbaïdjan",
    "BS": "Bahamas",
    "BH": "Bahreïn",
    "BD": "Bangladesh",
    "BB": "Barbade",
    "BY": "Biélorussie",
    "BE": "Belgique",
    "BZ": "Belize",
    "BJ": "Bénin",
    "BT": "Bhoutan",
    "BO": "Bolivie",
    "BA": "Bosnie-Herzégovine",
    "BW": "Botswana",
    "BR": "Brésil",
    "BN": "Brunéi",
    "BG": "Bulgarie",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodge",
    "CM": "Cameroun",
    "CA": "Canada",
    "CV": "Cap-Vert",
    "CF": "République centrafricaine",
    "TD": "Tchad",
    "CL": "Chili",
    "CN": "Chine",
    "CO": "Colombie",
    "KM": "Comores",
    "CG": "Congo (Brazzaville)",
    "CD": "Congo (Kinshasa)",
    "CR": "Costa Rica",
    "CI": "Côte d'Ivoire",
    "HR": "Croatie",
    "CU": "Cuba",
    "CY": "Chypre",
    "CZ": "République tchèque",
    "DK": "Danemark",
    "DJ": "Djibouti",
    "DM": "Dominique",
    "DO": "République dominicaine",
    "EC": "Équateur",
    "EG": "Égypte",
    "SV": "Salvador",
    "GQ": "Guinée équatoriale",
    "ER": "Érythrée",
    "EE": "Estonie",
    "ET": "Éthiopie",
    "FJ": "Fidji",
    "FI": "Finlande",
    "FR": "France",
    "GA": "Gabon",
    "GM": "Gambie",
    "GE": "Géorgie",
    "DE": "Allemagne",
    "GH": "Ghana",
    "GR": "Grèce",
    "GD": "Grenade",
    "GT": "Guatemala",
    "GN": "Guinée",
    "GW": "Guinée-Bissau",
    "GY": "Guyana",
    "HT": "Haïti",
    "HN": "Honduras",
    "HU": "Hongrie",
    "IS": "Islande",
    "IN": "Inde",
    "ID": "Indonésie",
    "IR": "Iran",
    "IQ": "Irak",
    "IE": "Irlande",
    "IL": "Israël",
    "IT": "Italie",
    "JM": "Jamaïque",
    "JP": "Japon",
    "JO": "Jordanie",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KW": "Koweït",
    "KG": "Kirghizistan",
    "LA": "Laos",
    "LV": "Lettonie",
    "LB": "Liban",
    "LS": "Lesotho",
    "LR": "Libéria",
    "LY": "Libye",
    "LI": "Liechtenstein",
    "LT": "Lituanie",
    "LU": "Luxembourg",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaisie",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malte",
    "MH": "Îles Marshall",
    "MR": "Mauritanie",
    "MU": "Maurice",
    "MX": "Mexique",
    "FM": "Micronésie",
    "MD": "Moldavie",
    "MC": "Monaco",
    "MN": "Mongolie",
    "ME": "Monténégro",
    "MA": "Maroc",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibie",
    "NR": "Nauru",
    "NP": "Népal",
    "NL": "Pays-Bas",
    "NZ": "Nouvelle-Zélande",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigéria",
    "KP": "Corée du Nord",
    "NO": "Norvège",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palaos",
    "PA": "Panama",
    "PG": "Papouasie-Nouvelle-Guinée",
    "PY": "Paraguay",
    "PE": "Pérou",
    "PH": "Philippines",
    "PL": "Pologne",
    "PT": "Portugal",
    "QA": "Qatar",
    "RO": "Roumanie",
    "RU": "Russie",
    "RW": "Rwanda",
    "KN": "Saint-Christophe-et-Niévès",
    "LC": "Sainte-Lucie",
    "VC": "Saint-Vincent-et-les-Grenadines",
    "WS": "Samoa",
    "SM": "Saint-Marin",
    "ST": "Sao Tomé-et-Principe",
    "SA": "Arabie saoudite",
    "SN": "Sénégal",
    "RS": "Serbie",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapour",
    "SK": "Slovaquie",
    "SI": "Slovénie",
    "SB": "Salomon",
    "SO": "Somalie",
    "ZA": "Afrique du Sud",
    "KR": "Corée du Sud",
    "SS": "Soudan du Sud",
    "ES": "Espagne",
    "LK": "Sri Lanka",
    "SD": "Soudan",
    "SR": "Suriname",
    "SZ": "Eswatini",
    "SE": "Suède",
    "CH": "Suisse",
    "SY": "Syrie",
    "TJ": "Tadjikistan",
    "TZ": "Tanzanie",
    "TH": "Thaïlande",
    "TL": "Timor oriental",
    "TG": "Togo",
    "TO": "Tonga",
    "TT": "Trinité-et-Tobago",
    "TN": "Tunisie",
    "TR": "Turquie",
    "TM": "Turkménistan",
    "TV": "Tuvalu",
    "UG": "Ouganda",
    "UA": "Ukraine",
    "AE": "Émirats arabes unis",
    "GB": "Royaume-Uni",
    "US": "États-Unis",
    "UY": "Uruguay",
    "UZ": "Ouzbékistan",
    "VU": "Vanuatu",
    "VA": "Cité du Vatican",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "YE": "Yémen",
    "ZM": "Zambie",
    "ZW": "Zimbabwe"
}
export default COUNTRY_CODE_NAME;